<template>
    <div class="form-group ">
        <label :for="name" v-if="!hideLabel">{{label}}</label>
        <select v-validate="validate"
                :value="value"
                @input="inputValue"
                :id="name"
                type="text"
                :data-vv-as="label"

                :placeholder="placeholder"
                class="form-control"
                :class="{'is-invalid':errors.has(name)}"
                :name="name">
            <option v-for="option in options" :value="option.value">{{option.text}}</option>
        </select>
        <div v-if="errors.has(name)" class="invalid-feedback">
            {{errors.first(name)}}
        </div>
    </div>
</template>

<script>
    import mixinField from '../../mixins/mixinField';

    export default {
        mixins: [mixinField],
        name: "FieldSelect",
        props: ['options'],
        data() {
            return {
                rules:""
            }
        },
    }
</script>

<style scoped>

    .custom-control-inline {
        margin-left: 1rem;
        margin-right: 0rem;
    }

    .list-group-item:first-child {
        border-top-left-radius: 0rem;
        border-top-right-radius: 0rem;
    }

</style>


// WEBPACK FOOTER //
// src/components/fields/FieldSelect.vue